var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningAcc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8C15 9.85652 14.2625 11.637 12.9497 12.9497C11.637 14.2625 9.85652 15 8 15C6.14348 15 4.36301 14.2625 3.05025 12.9497C1.7375 11.637 1 9.85652 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1ZM8 4C7.87304 3.99989 7.74745 4.02626 7.63125 4.07742C7.51506 4.12859 7.41081 4.20343 7.32518 4.29716C7.23954 4.39089 7.17439 4.50145 7.1339 4.62178C7.0934 4.74211 7.07845 4.86956 7.09 4.996L7.455 9.002C7.46915 9.13668 7.53267 9.26136 7.63331 9.35197C7.73395 9.44259 7.86458 9.49274 8 9.49274C8.13542 9.49274 8.26605 9.44259 8.36669 9.35197C8.46733 9.26136 8.53085 9.13668 8.545 9.002L8.909 4.996C8.92054 4.86965 8.90562 4.74228 8.86518 4.62202C8.82475 4.50176 8.75969 4.39124 8.67416 4.29753C8.58863 4.20381 8.48451 4.12895 8.36843 4.07772C8.25236 4.0265 8.12688 4.00003 8 4ZM8 12C8.21217 12 8.41566 11.9157 8.56569 11.7657C8.71571 11.6157 8.8 11.4122 8.8 11.2C8.8 10.9878 8.71571 10.7843 8.56569 10.6343C8.41566 10.4843 8.21217 10.4 8 10.4C7.78783 10.4 7.58434 10.4843 7.43431 10.6343C7.28429 10.7843 7.2 10.9878 7.2 11.2C7.2 11.4122 7.28429 11.6157 7.43431 11.7657C7.58434 11.9157 7.78783 12 8 12Z",
    fill: "url(#paint0_linear_2105_4132)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2105_4132",
    x1: 8,
    y1: 1,
    x2: 8,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8009E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8009E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningAcc);
export default __webpack_public_path__ + "static/media/WarningAcc.22250c9b921d042038b90858ec81d7f6.svg";
export { ForwardRef as ReactComponent };